import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, CanActivateChild, Route } from '@angular/router';
import { AccountService } from '../../account/services/account.service';
import { MatDialog } from '@angular/material';
import { ResellerInfoModel } from '../../account/models/profile/reellerInfoModel';
import { Location } from '@angular/common';
@Injectable()
export class MassPurchaseGuard implements CanActivate {
    constructor(private router: Router, private accountService: AccountService,
        public dialog: MatDialog,
        private location: Location,
        private route: Router) { }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        var result = false;
        await this.accountService.getResellerProfile().toPromise().then((res: ResellerInfoModel) => {
            if (!res.emailConfirmed)
                result = false;
            else if (res.emailConfirmed)
                result = true;
            else if (res.userStatus === 0 )
            {
                 //change user state from 0 to 4
                this.accountService.requestResseller().subscribe(()=>{
                    result = false;
                });
            }
            else if ( res.userStatus === 4)
                result = false;
            else if (res.userStatus === 1)
                result = false;
            else if (res.userStatus === 3)
                result = false;
            else if (!res.emailConfirmed)
                result = false;
            else result = true;
        },
            err => {
                return false;
            });


        if (result == false) {
            this.router.navigateByUrl('account/setting/seller');
            result = false;
        }
        return result;

    }
}
